import { BUYER_SMS_CONSENT_TEXT } from '@paction-2.0/util/constants/smsConsent';

import styles from './smsConsentNotice.module.scss';

type Props = {
  id?: string;
  className?: string;
};

export function SmsConsentNotice({ id, className }: Props) {
  return (
    <p
      id={id}
      className={className ? `${styles.notice} ${className}` : styles.notice}
    >
      {BUYER_SMS_CONSENT_TEXT} See our{' '}
      <a href="/terms-of-service" target="_blank" rel="noopener noreferrer">
        Terms of Service
      </a>{' '}
      and{' '}
      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      .
    </p>
  );
}
